
//房间状态 未开始 PREPARE 测试中 TESTING 进行中 ONGOING  已完成 COMPLETE  已取消 CANCEL 
export const ROOM_STATUS = { prepare: 'PREPARE', testing: 'TESTING', ongoing: 'ONGOING', complete: 'COMPLETE', cancel: 'CANCEL' };
// 会议状态(场景布局)(即将开始,中途暂停,中途休息,会议结束等等状态场景);
export const MEETING_STATUS = { not_started: 1, conduct: 2, suspend: 3, over: 4 };
// 用户类型 主持人,讲者,观众
// 6种身份角色 会议所有者 0、OWNER  讲者 1、SPEAKER  观众 2、AUDIENCE  会议主持人 3、   PRESENTER  小助手 4、ASSISTANT  飞检人员 5、AUDIT 
export const USER_TYPE = { master: 'OWNER', lecturer: 'SPEAKER', audience: 'AUDIENCE', presenter: 'PRESENTER', assistant: 'ASSISTANT', audit: 'AUDIT' };
// 参会模式
// INTERACTION_MODE:互动模式     
// GENERAL_MODE:普通模式
// PARALLEL_MODE:分会场模式
export const CURRENT_MODE = { INTERACTION_MODE: "INTERACTION_MODE", GENERAL_MODE: "GENERAL_MODE", PARALLEL_MODE: "PARALLEL_MODE" };
export const IM_STATUS = [
    {
        name: "IM正在初始化",
        successMessage: "IM初始化成功",
        errorMessage: "IM初始化失败",
        overtimeMessage: "IM初始化超时，请重试",
        isShow: false,
        status: 0,//0正在操作中,1,当前操作成功,2当前操作失败,3自动修复中,4检测超时
    },
    {
        name: "IMSDK检测中",
        successMessage: "IM SDK启动成功",
        errorMessage: "IM SDK启动失败",
        repairMessage: 'SDK进入NOT_READY状态，正在重新唤醒，请等待',
        overtimeMessage: "IM SDK检测超时，请重试",
        isShow: false,
        status: 0,//0正在操作中,1,当前操作成功,2当前操作失败,3自动修复中,4检测超时
    },
    {
        name: "IM登录中",
        successMessage: "IM登录成功",
        errorMessage: "IM登录失败",
        overtimeMessage: "IM登录超时，请重试",
        isShow: false,
        status: 0,//0正在操作中,1,当前操作成功,2当前操作失败,3自动修复中,4检测超时
    },
    {
        name: "IM加入会议中",
        successMessage: "IM加入会议成功",
        errorMessage: "IM加入会议失败",
        overtimeMessage: "IM加入会议超时，请重试",
        isShow: false,
        status: 0,//0正在操作中,1,当前操作成功,2当前操作失败,3自动修复中,4检测超时
    }
];
export const TRTC_STATUS = [
    {
        name: "TRTC正在初始化",
        successMessage: "TRTC初始化成功",
        errorMessage: "TRTC初始化失败",
        overtimeMessage: "TRTC初始化超时，请重试",
        isShow: false,
        status: 0,//0正在操作中,1,当前操作成功,2当前操作失败,3自动修复中,4检测超时
    },
    {
        name: "TRTC加入会议中",
        successMessage: "TRTC加入会议成功",
        errorMessage: "TRTC加入会议失败",
        overtimeMessage: "TRTC加入会议超时，请重试",
        isShow: false,
        status: 0,//0正在操作中,1,当前操作成功,2当前操作失败,3自动修复中,4检测超时
    },
    {
        name: "加载远端流",
        successMessage: "加载远端流成功",
        errorMessage: "加载远端流失败",
        overtimeMessage: "加载远端流超时，请重试",
        isShow: false,
        status: 0,//0正在操作中,1,当前操作成功,2当前操作失败,3自动修复中,4检测超时
    },
    {
        name: "创建本地视频",
        successMessage: "创建本地视频成功",
        errorMessage: "创建本地视频失败",
        overtimeMessage: "创建本地视频超时，请重试",
        isShow: false,
        status: 0,//0正在操作中,1,当前操作成功,2当前操作失败,3自动修复中,4检测超时
    },
    {
        name: "发布本地视频",
        successMessage: "发布本地视频成功",
        errorMessage: "发布本地视频失败",
        overtimeMessage: "发布本地视频超时，请重试",
        isShow: false,
        status: 0,//0正在操作中,1,当前操作成功,2当前操作失败,3自动修复中,4检测超时
    }
];
// 网页开播微信appid
export const APPID = 'wx0eae9693def0446c'; // 开发环境
export const devAPPID = 'wxce1356f5a5c13f36'; // 测试环境



// WEBPACK FOOTER //
// ./src/util/constants.js